import React, { useGlobal } from 'reactn';
import { Route, Redirect } from 'react-router-dom';

const PublicRoute = ({user, children, restricted, ...rest}) => {
  return (
    <Route {...rest}>
      { user && restricted ? <Redirect to="/"/> : children }
    </Route>
  );
}

export default PublicRoute;
